import React from "react";
import {
  ActivePlacements,
  Divider,
  StatusTags,
  Tag,
  Placements,
  Button,
  CustomTag,
  SelectStatusTags,
} from "../../../../components";

const handleEdit = (row) => {
  alert(row.id);
};

const placementsData = [
  {
    company: "Google",
    jobTitle: "Software Engineer",
    employmentType: "Full-time",
    location: "California, USA",
    salary: "120K USD",
    workMode: "Remote",
    visaSponsorship: "Yes",
    experienceRequired: "5 years",
  },
  {
    company: "Amazon",
    jobTitle: "Data Scientist",
    employmentType: "Contract",
    location: "Seattle, USA",
    salary: "110K USD",
    workMode: "Hybrid",
    visaSponsorship: "No",
    experienceRequired: "3 years",
  },
  {
    company: "Microsoft",
    jobTitle: "Product Manager",
    employmentType: "Full-time",
    location: "Washington, USA",
    salary: "130K USD",
    workMode: "On-site",
    visaSponsorship: "Yes",
    experienceRequired: "6 years",
  },
  {
    company: "Tesla",
    jobTitle: "Electrical Engineer",
    employmentType: "Internship",
    location: "Texas, USA",
    salary: "80K USD",
    workMode: "On-site",
    visaSponsorship: "No",
    experienceRequired: "2 years",
  },
];

const newPlacementsData = placementsData.map((item, index) => ({
  id: index + 1,
  ...item,
}));

// Example usage:
const customColumns = [
  // Exclude a column
  "id",
  "experienceRequired",

  // Custom render for existing column
  {
    key: "jobTitle",
    label: "Job Title",
    render: (row) => (
      <div className="flex items-center gap-1">
        <span className="text-linkblue">{row.jobTitle}</span>
      </div>
    ),
  },

  // Add new column
  {
    key: "action",
    label: "Action",
    render: (row) => (
      <Button
        type="icon"
        variant="text"
        icon="edit"
        size="xs"
        color="black"
        onClick={() => handleEdit(row)}
      />
    ),
    sortable: false,
  },
];

const TagsItems = ({ size = "md" }) => {
  const colors = [
    "primary",
    "warning",
    "success",
    "danger",
    "info",
    "black",
    "white",
  ];
  const variants = ["contained", "outlined", "text"];
  const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
  const statusTags = [
    "Active",
    "On hold",
    "Rejected",
    "Inactive",
    "Unknown",
    "Exit",
  ];
  const icons = [true, false];

  return (
    <div className="flex flex-col gap-10 flex-1 overflow-auto">
      <div className="flex gap-5 items-center">
        <Placements
          content={10}
          data={newPlacementsData}
          columnData={customColumns}
        />
        <Placements content={10} data={[]} />
      </div>
      <div className="flex gap-5 items-center">
        {colors.map((color, index) => (
          <div key={index} className="flex flex-col gap-5">
            {variants.map((variant, index) => (
              <div key={index}>
                <Tag
                  title={color}
                  size={size}
                  color={color}
                  variant={variant}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
      <Divider />
      <div className="flex gap-5 items-center">
        {sizes.map((size, index) => (
          <div key={index}>
            <Tag title={size} size={size} />
          </div>
        ))}
      </div>
      <Divider />
      <div className="flex gap-5 items-center">
        {statusTags.map((statusTag, index) => (
          <div key={index} className="flex flex-col gap-5">
            {variants.map((variant, index) => (
              <div key={index} className="flex flex-col gap-5">
                {icons.map((icon, index) => (
                  <div key={index}>
                    <StatusTags tag={statusTag} variant={variant} icon={icon} />
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
      <Divider />
      <div className="flex gap-5 items-center">
        {sizes.map((size, index) => (
          <div key={index}>
            <StatusTags tag={"Active"} size={size} />
          </div>
        ))}
      </div>
      <Divider />
      <div className="flex gap-3">
        <CustomTag
          count={"75"}
          description={"Consultant Worked"}
          icon={"directions_run"}
          color={"warning"}
          size={"xs"}
        />
        <CustomTag
          count={"75"}
          description={"Consultant Worked"}
          icon={"directions_run"}
          color={"danger"}
          size={"xs-sm"}
        />
        <CustomTag
          count={"75"}
          description={"Consultant Worked"}
          icon={"directions_run"}
          color={"info"}
          size={"sm"}
        />
        <CustomTag
          count={"75"}
          description={"Consultant Worked"}
          icon={"directions_run"}
          color={"success"}
          size={"md"}
        />
        <CustomTag
          count={"98"}
          description={"Active Consultants"}
          icon={"hail"}
          color="success"
          size={"lg"}
        />
      </div>

      <Divider />
      <div className="flex gap-5">
        <SelectStatusTags
          options={[
            { label: "Active", value: 1 },
            { label: "Inactive", value: 2 },
            { label: "Blocked", value: 3 },
          ]}
        />
      </div>

      {/* <div>tag2</div> */}

      {/* <div className="flex gap-5 items-center">
        <Tag title={"Primary"} size={size} color="primary" />
        <Tag title={"Primary"} size={size} color="primary" variant="outlined" />
        <Tag title={"Primary"} size={size} color="primary" variant="text" />
      </div>
      <div className="flex gap-5 items-center">
        <Tag title={"Warning"} size={size} color="warning" />
        <Tag title={"Warning"} size={size} color="warning" variant="outlined" />
        <Tag title={"Warning"} size={size} color="warning" variant="text" />
      </div>
      <div className="flex gap-5 items-center">
        <Tag title={"Success"} size={size} color="success" />
        <Tag title={"Success"} size={size} color="success" variant="outlined" />
        <Tag title={"Success"} size={size} color="success" variant="text" />
      </div>
      <div className="flex gap-5 items-center">
        <Tag title={"Danger"} size={size} color="danger" />
        <Tag title={"Danger"} size={size} color="danger" variant="outlined" />
        <Tag title={"Danger"} size={size} color="danger" variant="text" />
      </div>
      <div className="flex gap-5 items-center">
        <Tag title={"Black"} size={size} color="black" />
        <Tag title={"Black"} size={size} color="black" variant="outlined" />
        <Tag title={"Black"} size={size} color="black" variant="text" />
      </div>
      <div className="flex gap-5 items-center">
        <Tag title={"White"} size={size} color="white" />
        <Tag title={"White"} size={size} color="white" variant="outlined" />
        <Tag title={"White"} size={size} color="white" variant="text" />
      </div>
      <div className="flex gap-5 items-center">
        <StatusTags tag="Active" size={size} />
        <StatusTags tag="On hold" size={size} />
        <StatusTags tag="Rejected" size={size} />
        <StatusTags tag="Inactive" size={size} />
        <StatusTags tag="Unknown" size={size} />
        ---
        <StatusTags tag="Active" icon size={size} />
        <StatusTags tag="On hold" icon size={size} />
        <StatusTags tag="Rejected" icon size={size} />
        <StatusTags tag="Inactive" icon size={size} />
        <StatusTags tag="Unknown" icon size={size} />
      </div>
      <div className="flex gap-5 items-center">
        <ActivePlacements size={size} />
        <ActivePlacements count={2} size={size} />
      </div> */}
    </div>
  );
};

export default TagsItems;
